import { jsx as _jsx } from "react/jsx-runtime";
import { format as fnsFormat, parseISO } from "date-fns";
export function DateSpan({ iso, format }) {
    const parsedDate = iso ? parseISO(iso) : undefined;
    const formatedDate = parsedDate
        ? fnsFormat(parsedDate, format || "PPP")
        : undefined;
    return (_jsx("span", { "data-testid": "date", className: `block text-gray-500 uppercase font-semibold text-xs tracking-wide mb-1`, children: formatedDate || " " }));
}
